/**
 * Why core-api is closing a socket. Carried on {@link WebsocketSessionMessageEnum.SESSION_CLOSING}.
 */
export enum WebsocketSessionCloseCodeEnum {
  /** The access token that opened this socket reached `exp`. */
  EXPIRED = 'expired',
  /** `POST /admin/auth/sign-out` was received for this session. */
  SIGNED_OUT = 'signed_out',
  /** The session's verified tenant no longer matches the tenant this socket joined. */
  TENANT_CHANGED = 'tenant_changed',
}
